module.exports = __webpack_public_path__ + "img/11@3x.6ddfe11c.png";